import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useRef } from "react";
import _ from "underscore";
import { convertToBase64 } from "../../../utils/Helper"
import { ToastContext } from "../../../context/ToastContext";
import PasteAndDropImageHandler from "../PasteAndDropImageHandler/PasteAndDropImageHandler";

const CommonImage = ({ type, height, selectedImages, setSelectedImages, width, disabled, is_paste, hideImage }) => {

    const fileInputRef = useRef(null);
    const { showError } = useContext(ToastContext);

    const handleFileChange = async (event) => {
        const allImages = [...selectedImages];
        const files = event.target.files;
        if (files) {
            Array.from(files).forEach(async (file) => {
                const maxSizeInBytes = 50 * 1024 * 1024;
                if (file.size >= maxSizeInBytes) {
                    showError("Error", "File size should not exceed 50MB");
                    return;
                }

                const isDuplicate = selectedImages.some((existingFile) => {
                    if (typeof existingFile?.file === "string") return false;

                    return (
                        existingFile?.file?.name === file.name &&
                        existingFile?.file?.size === file.size &&
                        existingFile?.file?.lastModified === file.lastModified
                    );
                });

                if (!isDuplicate) {
                    const baseString = await convertToBase64(file);
                    allImages.push({ file: file, base64: baseString?.split(",")?.[1], base64FullString: baseString });
                    setSelectedImages([...allImages]);
                }
            })
        }

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    const handleDeleteImage = (index) => {
        setSelectedImages(_.filter(selectedImages, (_, idx) => idx !== index));

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }


    return (
        <div>
            {type === "upload" && <div className="d-flex gap-4">
                <input ref={fileInputRef} type="file" className={`${is_paste ? "w50" : "w100"}`} multiple accept={hideImage ? " video/*,image/*,application/pdf" : "image/*,application/pdf"} onChange={(e) => handleFileChange(e)} disabled={disabled} />
                {
                    is_paste &&
                    <PasteAndDropImageHandler selectedImages={selectedImages} setSelectedImages={setSelectedImages} disabled={disabled} />
                }
            </div>}
            <div className="d-flex gap-2 mt-2 flex-wrap">
                {!hideImage && !_.isEmpty(selectedImages) && selectedImages?.map((item, index) => (
                    <div className="position-relative" key={index}>
                        <a href={item?.file ? (typeof (item?.file) === 'string' ? item?.file : URL.createObjectURL(item?.file)) : ""} target="_blank" >
                            <img className="rounded" src={typeof (item?.file) === 'string' ? item?.file : URL.createObjectURL(item?.file)} style={{ height: height ? height : type === "upload" ? "80px" : "150px", width: width ? width : type === "upload" ? "80px" : "150px" }} />
                        </a>
                        {type === "upload" &&
                            <span className="position-absolute bg-danger text-white d-flex justify-content-center align-items-center rounded top-0 end-0 c-pointer" style={{ width: "18px", height: "18px" }} onClick={() => handleDeleteImage(index)}>
                                <FontAwesomeIcon icon="fa-solid fa-close" />
                            </span>
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CommonImage